//import ExcelColumnData from '@/types/app/excelColumnData';
import FeedBack from '@/types/feedBack';
import { FeedBackStateInterface } from './types';

export default {
  getFeedBack(state: FeedBackStateInterface): FeedBack {
    return state.feedBack;
  }
};
